import { getSizeStyles } from './size/getSizeStyles';
import { mergeStyles } from '../../../../../../../internal/utils/mergeStyles';
export function getTabletDesktopStyles(size) {
  var deviceStyles = require('./styles.module.css');
  var sizeStyles = getSizeStyles(size);
  return mergeStyles(deviceStyles, sizeStyles);
}